import { Box, Divider, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import Label from 'src/components/Label';
import Scrollbar from 'src/components/Scrollbar';

const getStatusLabel = (status) => {
    switch (status) {
      case 1:  return '🆕 New';
      case 21: return '❓ Clarification Needed';
      case 6:  return '📌 Assigned';
      case 2:  return '🛠️ In Progress';
      case 7:  return '⏳ Waiting for Development';
      case 8:  return '👨‍💻 In Development';
      case 9:  return '📤 Sent to QA';
      case 10: return '🔍 QA in Progress';
      case 11: return '❌ QA Failed';
      case 12: return '✅ QA Passed';
      case 14: return '🕰️ Waiting for Client Approval';
      case 18: return '✅ Client Approved';
      case 20: return '❗ Client Rejected';
      case 15: return '✏️ Changes Requested';
      case 13: return '🚀 Moved to Production';
      case 4:  return '🕒 Re-opened';
      case 16: return '⚠️ Escalated';
      case 3:  return '✅ Completed';
      case 5:  return '🚫 Cancelled';
      case 17: return '⏸️ On Hold';
      case 19: return '🔒 Closed';
      default: return '❓ Unknown';
    }
  };
  
const getPriorityLabel = (priority) => {
    switch (priority) {
        case 1: return { label: 'High', icon: 'lsicon--double-arrow-up-outline', color: '#ff3f19' };
        case 2: return { label: 'Medium', icon: 'uil--grip-horizontal-line', color: '#ffff00' };
        case 3: return { label: 'Low', icon: 'ri--arrow-down-double-fill', color: '#00cd00' };
        default: return { label: 'Unknown', icon: 'ri-question-fill', color: '#ff0000' };
    }
};

const DailyTicketSummary = ({ ticketSummaryData }) => {
    const today = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    const groupedTickets = ticketSummaryData.reduce((acc, ticket) => {
        const status = ticket.status || 0;
        const ticketID = ticket.ID;
        const priority = ticket.priority || '0';
        if (!ticketID) return acc;
        if (!acc[status]) {
            acc[status] = [];
        }
        acc[status].push({ id: ticketID, priority });
        return acc;
    }, {});

    return (
        <Grid py={2}>
           <Grid >
                <Typography sx={{ display: 'flex', justifyContent: 'center' }} variant="h6" gutterBottom>
                    🗓️ Daily Ticket Summary – [Date: {today}]
                </Typography>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2} justifyContent={{ xs: 'flex-start', md: 'space-between' }} alignItems={{ xs: 'flex-start', md: 'center' }}>
                    <Stack sx={{ p: 2, display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'flex-end' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>

                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Priority :</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Box sx={{ width: 20, height: 20, backgroundColor: "#ff3f19", borderRadius: 0.5 }} />
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>High</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Box sx={{ width: 20, height: 20, backgroundColor: "#ffff00", borderRadius: 0.5 }} />
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Medium</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Box sx={{ width: 20, height: 20, backgroundColor: "#00cd00", borderRadius: 0.5 }} />
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Low</Typography>
                        </Box>
                    </Stack>
                    {/* <Stack sx={{ p: 2, display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'flex-end' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>

                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Ticket Type :</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Label
                                variant='filled'
                                color='error'
                                sx={{
                                    width: 'fit-content',
                                    height: 'fit-content',
                                    minWidth: 0,
                                    p: '3px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'common.white'
                                }}
                            >
                                <Stack className='ri--bug-fill' />
                            </Label>
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Bug</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Label
                                variant='filled'
                                color='purple'
                                sx={{
                                    width: 'fit-content',
                                    height: 'fit-content',
                                    minWidth: 0,
                                    p: '3px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'common.white'
                                }}
                            >
                                <Stack className='cuida--bookmark-outline' />
                            </Label>
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Story</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer', }}>
                            <Label
                                variant='filled'
                                color='success'
                                sx={{
                                    width: 'fit-content',
                                    height: 'fit-content',
                                    minWidth: 0,
                                    p: '3px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'common.white'
                                }}
                            >
                                <Stack className='bx--task' />
                            </Label>
                            <Typography sx={{ pl: 1, fontSize: '14px' }}>Task</Typography>
                        </Box>
                    </Stack> */}
                </Stack>
           </Grid>           
           <Scrollbar>
            <TableContainer
                component={Paper}
                sx={{
                    maxHeight: '300px',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#1e1e1e',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#888',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                    },
                    '&.white-space-text': {
                        whiteSpace: 'nowrap',
                    },
                }}
            >
                
                    <Table size="small" aria-label="ticket summary table" stickyHeader>
                        <TableHead >
                            <TableRow>
                                <TableCell><strong>Status</strong></TableCell>
                                <TableCell><strong>Count</strong></TableCell>
                                <TableCell><strong>Ticket IDs</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.entries(groupedTickets).map(([status, tickets]) => (
                                <TableRow key={status}>
                                    <TableCell className='white-space-text' sx={{ whiteSpace: 'nowrap' }}>
                                        <Typography variant='body2'>{getStatusLabel(Number(status))}</Typography>
                                    </TableCell>
                                    <TableCell><Typography variant='body2'>{tickets.length}</Typography></TableCell>
                                    <TableCell>
                                        <Typography variant="body2" component="div" dangerouslySetInnerHTML={{
                                            __html: tickets
                                                .map(({ id, priority }) => {
                                                    const { label, icon, color } = getPriorityLabel(priority);
                                                    // return `SW-${id} <i class="${icon}" style="margin: 0 4px;"></i>`;
                                                    return `<span style="color:${color}">SW-${id}</span>`;
                                                })
                                                .join(', ')
                                        }} />
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                        
                    </Table>
            </TableContainer>
            </Scrollbar>
           
        </Grid>
    );
};

export default DailyTicketSummary;